(() => {
  'use strict';
  const marker = document.getElementById('tbc-clarity-trial');
  if (!marker || marker.dataset.initialized) return;
  marker.dataset.initialized = 'true';
  const state = value => { marker.dataset.state = value; };
  const allowedQuery = /^(variant|utm_(source|medium|campaign|content|term|id)|gclid|gbraid|wbraid|msclkid|fbclid)$/;
  const unsafeQuery = [...new URLSearchParams(location.search)].some(([key, value]) =>
    !allowedQuery.test(key) || /@/.test(value));
  if (unsafeQuery || location.hash || navigator.globalPrivacyControl === true) {
    state('excluded');
    return;
  }
  let loaded = false;
  let stopped = false;
  let retries = 0;
  const sync = () => {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.currentVisitorConsent !== 'function') {
      state('waiting-for-consent-api');
      return;
    }
    const consent = privacy.currentVisitorConsent();
    const permitted = consent.analytics === 'yes' && privacy.analyticsProcessingAllowed() === true;
    if (!permitted) {
      state('blocked-by-consent');
      if (loaded && !stopped) {
        window.clarity('consentv2', { ad_Storage: 'denied', analytics_Storage: 'denied' });
        window.clarity('stop');
        stopped = true;
      }
      return;
    }
    if (stopped) {
      state('awaiting-next-page-after-reconsent');
      return;
    }
    if (loaded) return;
    if (window.clarity || document.querySelector('script[src*="clarity.ms/tag/"]')) {
      state('existing-installation-detected');
      return;
    }
    loaded = true;
    document.body.setAttribute('data-clarity-mask', 'true');
    window.clarity = function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };
    window.clarity('consentv2', { ad_Storage: 'denied', analytics_Storage: 'granted' });
    const tag = document.createElement('script');
    tag.async = true;
    tag.src = 'https://www.clarity.ms/tag/z0lvhccsdz';
    tag.onload = () => {
      if (!stopped) state('loaded-after-consent');
    };
    tag.onerror = () => state('script-unavailable');
    state('loading-after-consent');
    document.head.appendChild(tag);
  };
  const ready = () => {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      sync();
    } else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => {
        if (error) state('consent-api-unavailable');
        else sync();
      });
    } else if (++retries <= 20) {
      setTimeout(ready, 250);
    } else {
      state('consent-api-unavailable');
    }
  };
  document.addEventListener('visitorConsentCollected', sync);
  window.addEventListener('pageshow', sync);
  state('waiting-for-consent');
  ready();
})();
